import React from "react";
import PropTypes from "prop-types";
import { List, Grid3X3 } from "lucide-react";
import {Button} from "@/components/ui/button";

const ToggleSwitcher = ({ value = "Grid", onChange }) => {
  const options = [
    {
      label: "Grid",
      icon: <Grid3X3 className="h-4 w-4" />,
      value: "Grid",
    },
    {
      label: "Table",
      icon: <List className="h-4 w-4" />,
      value: "table",
    },
  ];

  return (
    <div className="flex items-center space-x-1 bg-muted p-1 rounded-lg">
         <Button
           variant={value === "Grid" ? "default" : "ghost"}
           size="sm"
           onClick={() => onChange('Grid')}
           className="h-8 px-3"
         >
           <Grid3X3 className="h-4 w-4" />
         </Button>
         <Button
           variant={value === "table" ? "default" : "ghost"}
           size="sm"
           onClick={() => onChange('table')}
           className="h-8 px-3"
         >
           <List className="h-4 w-4" />
         </Button>
       </div>
  );
};

ToggleSwitcher.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default ToggleSwitcher;
